import React, { FC } from "react";
import { BASE_URL } from "../../api/config";
import BottomSlider from "../../components/BottomSlider/BottomSlider";
import Button, { ButtonModeE } from "../../components/Button/Button";
import Icon from "../../components/Icon/Icon";
import { Span } from "../../components/Text/Text";

import styles from "./downloadSlider.module.scss";

type DownloadSliderPropTypes = {
  showBottomSlider: boolean;
  isUploading: boolean;
  toggleShow: () => void;
  handleDownload: (data: any) => void;
};

const DownloadSlider: FC<DownloadSliderPropTypes> = (props) => {
  const {
    showBottomSlider,
    isUploading,
    toggleShow,
    handleDownload,
  } = props;

  return (
    <div>
      <BottomSlider
        visible={showBottomSlider}
        onClose={toggleShow}
        title="Download Preview"
      >
        <div className={styles.sliderWrapper}>
          <div className={styles.info}>
            <Icon name="videoPlayerInfo" />
            <Span>
              Preview has low resolution. Video that will be sent for download
              will have the original format and broadcasting quality.
            </Span>
          </div>
          <div className={styles.sliderButtons}>
            <div className={styles.downloadButtonWrapper}>
              <Button onClick={handleDownload} loading={isUploading} disabled={isUploading}>Download preview</Button>
            </div>
            <Button mode={ButtonModeE.OUTLINED} onClick={toggleShow}>
              Cancel
            </Button>
          </div>
        </div>
      </BottomSlider>
    </div>
  );
};

export default DownloadSlider;
